import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {FormArray, FormControl, FormGroup} from '@angular/forms';
import {MessageService} from 'primeng/api';
import {AdminControlService} from "../../../@shared/services/admin-control.service";
import {CacheService} from "../../../@shared/services/cache.service";
import {ImUserService} from "../../../@shared/services/im-user.service";

export enum Mode {
    create = 'create',
    update = 'update'
}

@Component({
    selector: 'app-update-roles',
    templateUrl: './update-roles.component.html',
    styleUrls: ['./update-roles.component.scss']
})
export class UpdateRolesComponent implements OnInit {
    role: any;
    roleFormArray: FormArray | any = new FormArray([]);
    isLoading: boolean;
    currentMode: Mode;
    fpModules: any[] = [];
    roleId: any;
    roleForm: FormGroup;
    toggleDisabledField: boolean;
    loggedInUser = this.cacheService.retrieveParsedResponse('detailedLoggedInUser');
    adminRoles: any;

    constructor(private adminRoute: AdminControlService, private activatedRoute: ActivatedRoute, private messageService: MessageService,
                private cacheService: CacheService,
                private imUserService: ImUserService) {
    }

    ngOnInit(): void {
        this.roleDetailForm();
        this.getAllFpModule();
        this.getAdminRolesDropdown();
        this.activatedRoute.queryParams.subscribe((x) => {
            this.roleId = x?.roleId;
            // console.log(roleId, 'Id on ngOnInint');
            if (this.roleId) {
                this.currentMode = Mode.update;
                this.toggleDisabledField = false;
            } else {
                this.currentMode = Mode.create;
                this.toggleDisabledField = true;
                this.createNewRoleForm();

            }
        });
    }

    getAllFpModule() {
        this.adminRoute.getAllFpModule()
            .subscribe((res) => {
                res.map((x) => {
                    this.fpModules.push(x);
                });
                if (this.currentMode === 'update') {
                    this.getRoleByRoleId(this.roleId);
                } else {
                    this.createNewRoleForm();
                }
            }, error => {
                this.messageService.add({
                    summary: 'Unable to Module !',
                    severity: 'error',
                    detail: error?.message ? error?.message : error,
                    key: 'error-message',
                    sticky: true
                });
            });
    }

    createNewRoleForm() {
        this.fpModules.map((x) => {
            x.roleModuleId = x.roleModuleId;
            x.roleId = x.roleId;
            x.moduleId = x.moduleId;
            x.isViewAllowed = x.isViewAllowed;
            x.isEditAllowed = x.isEditAllowed;
            x.isDeleteAllowed = x.isDeleteAllowed;
            x.label = x.moduleName;
            this.roleConfigForm(x);
        });
    }

    getRoleByRoleId(roleId?: string) {
        this.isLoading = true;
        this.roleFormArray = new FormArray([]);
        // if (this.currentMode === 'update') {
        this.adminRoute.getRoleByRoleId(roleId)
            .subscribe((res) => {
                this.isLoading = false;
                this.role = res;
                this.roleDetailForm(res);
                this.role?.roleModuleAccessList.map((x) => {
                    this.fpModules?.map((module: any) => {

                        if (x.moduleId === module.moduleId) {
                            x.label = module.moduleName;
                            return;
                        }
                    });
                    this.roleConfigForm(x);
                });
            }, (error) => {
                this.isLoading = false;
                this.messageService.add({
                    summary: 'Unable to get Roles !',
                    severity: 'error',
                    detail: error?.message ? error?.message : error,
                    key: 'error-message',
                    sticky: true
                });
            });
        // }
    }

    roleDetailForm(updateRoleDetails?: any) {
        this.roleForm = new FormGroup({
            roleId: new FormControl(updateRoleDetails?.roleId ? updateRoleDetails?.roleId : ''),
            isActive: new FormControl(updateRoleDetails?.isActive),
            name: new FormControl(updateRoleDetails?.name ? updateRoleDetails?.name : ''),
            assignedParentRole: new FormControl(updateRoleDetails?.assignedParentRole ? updateRoleDetails?.assignedParentRole : null),
        });
    }


    roleConfigForm(updateRoleDetails?: any) {
        const roleConfigListForm = new FormGroup({
            roleId: new FormControl(updateRoleDetails?.roleId ? updateRoleDetails?.roleId : ''),
            isActive: new FormControl(updateRoleDetails?.isActive ? updateRoleDetails?.isActive : true),
            name: new FormControl(updateRoleDetails?.name ? updateRoleDetails?.name : ''),
            label: new FormControl(updateRoleDetails?.label ? updateRoleDetails?.label : ''),
            isViewAllowed: new FormControl(updateRoleDetails?.isViewAllowed ? updateRoleDetails?.isViewAllowed : false),
            isEditAllowed: new FormControl(updateRoleDetails?.isEditAllowed ? updateRoleDetails?.isEditAllowed : false),
            isDeleteAllowed: new FormControl(updateRoleDetails?.isDeleteAllowed ? updateRoleDetails?.isDeleteAllowed : false),
            roleModuleId: new FormControl(updateRoleDetails?.roleModuleId ? updateRoleDetails?.roleModuleId : ''),
            moduleId: new FormControl(updateRoleDetails?.moduleId ? updateRoleDetails?.moduleId : ''),
        });
        this.roleFormArray.push(roleConfigListForm);
    }

    updateRoleConfig() {
        this.isLoading = true;
        const roleDetail = this.roleForm.value;
        const roleConfigPayLoad = this.roleFormArray.value;
        const roleRequestObject = {
            roleId: roleDetail?.roleId ? roleDetail?.roleId : null,
            name: roleDetail?.name ? roleDetail?.name : null,
            isActive: roleDetail?.isActive ? roleDetail?.isActive : false,
            assignedParentRole: roleDetail?.assignedParentRole ? roleDetail?.assignedParentRole : null,
            roleModuleAccessList: roleConfigPayLoad
        };
        // if (this.currentMode === 'update') {
        this.adminRoute.updateRole(roleRequestObject)
            .subscribe((res) => {
                this.isLoading = false;
                this.messageService.add({
                    summary: 'Role Updated...',
                    severity: 'success',
                    detail: 'Selected Role Updated..',
                    key: 'success-message',
                    sticky: true
                });
            }, error => {
                this.isLoading = false;
                this.messageService.add({
                    summary: 'Unable to Update Selected Roles !',
                    severity: 'error',
                    detail: error?.message ? error?.message : error,
                    key: 'error-message',
                    sticky: true
                });
            });
        // }
    }

    createRoleConfig() {
        this.isLoading = true;
        const roleConfigPayload = this.roleFormArray.value;
        const roleDetails = this.roleForm.value;
        const roleVO = {
            assignedParentRole: roleDetails?.assignedParentRole,
            isActive: roleDetails?.isActive,
            name: roleDetails?.name,
            roleId: roleDetails?.roleId,
            roleModuleAccessList: roleConfigPayload
        };
        if (!roleDetails?.name) {
            this.isLoading = false;
            this.messageService.add({
                summary: 'Role',
                severity: 'info',
                detail: 'Please enter role name !',
                key: 'success-message',
            });
            return;
        }
        this.adminRoute.createRole(roleVO)
            .subscribe((res) => {
                this.isLoading = false;
                this.messageService.add({
                    summary: 'Role Created...',
                    severity: 'success',
                    detail: 'New Role Created..',
                    key: 'success-message',
                    sticky: true
                });
            }, error => {
                this.isLoading = false;
                this.messageService.add({
                    summary: 'Unable to Create New Roles !',
                    severity: 'error',
                    detail: error?.message ? error?.message : error,
                    key: 'error-message',
                    sticky: true
                });
            });
        console.log(roleDetails?.name, 'this.roleFormArray.control.value');
    }

    getAdminRolesDropdown() {
        this.imUserService
            .getAdminRolesDropdown()
            .subscribe(
                (x) => {
                    this.adminRoles = x;
                }, (error) => {
                    this.messageService.add({
                        summary: 'Admin Roles !',
                        severity: 'error',
                        detail: error?.message ? error?.message : error,
                        key: 'error-message',
                    });
                }
            );
    }
}
